/**
 * Convert total seconds to "HH:mm" format string.
 * e.g. 1800 => "00:30", 3661 => "01:01"
 */
export const secondsToHHmm = (totalSeconds) => {
    if (totalSeconds === undefined ||
        totalSeconds === null ||
        isNaN(totalSeconds)) {
        return "00:00";
    }
    const absSeconds = Math.abs(Math.floor(totalSeconds));
    const hours = Math.floor(absSeconds / 3600);
    const minutes = Math.floor((absSeconds % 3600) / 60);
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};
/**
 * Convert "HH:mm" format string to total seconds.
 * e.g. "00:30" => 1800, "01:01" => 3660
 */
export const hhmmToSeconds = (hhmm) => {
    if (!hhmm || typeof hhmm !== "string")
        return 0;
    const parts = hhmm.split(":");
    if (parts.length !== 2)
        return 0;
    const hours = parseInt(parts[0], 10) || 0;
    const minutes = parseInt(parts[1], 10) || 0;
    return hours * 3600 + minutes * 60;
};
/**
 * Validate "HH:mm" format. Returns true if valid.
 */
export const isValidHHmm = (value) => {
    if (!value)
        return false;
    const regex = /^\d{1,2}:\d{2}$/;
    if (!regex.test(value))
        return false;
    const parts = value.split(":");
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    return hours >= 0 && hours <= 99 && minutes >= 0 && minutes <= 59;
};
